export const productsData = [
  {
    id: 1,
    image: 'https://i.postimg.cc/vZN2vCxf/Group-575.png',
    info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
    price: '9,999',
    discound: '50%',
    from: 'UK',
    to: 'Egypt',
    inDays: 2,
    rate: '4.5 of 5',
  },

  {
    id: 2,
    image: 'https://i.postimg.cc/kGRgB0Ss/Group-583.png',
    info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
    price: '9,999',
    discound: '50%',
    from: 'UK',
    to: 'Egypt',
    inDays: 2,
    rate: '4.5 of 5',
  },

  {
    id: 3,
    image: 'https://i.postimg.cc/NjkmsXBM/Group-589.png',
    info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
    price: '9,999',
    discound: '50%',
    from: 'UK',
    to: 'Egypt',
    inDays: 2,
    rate: '4.5 of 5',
  },

  {
    id: 4,
    image: 'https://i.postimg.cc/fbWXJbRv/Group-597.png',
    info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
    price: '9,999',
    discound: '50%',
    from: 'UK',
    to: 'Egypt',
    inDays: 2,
    rate: '4.5 of 5',
  },
];
